// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2j22v","label":"LabeledBox_label__1cupp"};